import { render, staticRenderFns } from "./metrics_reports_issue_body.vue?vue&type=template&id=ced331f0&"
import script from "./metrics_reports_issue_body.vue?vue&type=script&lang=js&"
export * from "./metrics_reports_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports